import { API } from '../../API/api';
import {loadVariables} from './load_variables';

const REQUEST_CONFIG = {
    apiPath: '/api/v2/cms/variables/',
    data: '',
    dataType: 'json'
};

export const onSuccess = response => {
    loadVariables(response);
};

export const onError = error =>
    console.warn('Couldn\'t fetch cms variables');

export const getCmsVariables = () => API
    .GET(REQUEST_CONFIG)
    .then(onSuccess)
    .catch(onError);

export const fetchCmsVariables = async function() {
    try {
        await getCmsVariables();
    } catch (error) {
        console.warn('Couldn\'t fetch cms variables: ' + error);
    }
};
